import { Col, Row } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import CustomCard from '../../../components/Antd/Card';
import CustomImage from '../../../v2-components/Antd/Image';
import CustomLink from '../../../v2-components/Antd/Link';
import LoadingModal from '../../../v2-components/LoadingModal';
import { CustomNotification } from '../../../v2-components/Notification';
import { Service } from '../service';
import { platformNames } from '../constants/platform-names.contants';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import './style.scss';
import Loading from '../../../v2-components/Loading';
import usePharmacyUserIconStore from './store/pharmacy-store';

export default function PharmacyIconTemplatesPage() {
	const [loading, setLoading] = useState(false);
	const [openLoadingModal] = useState(false);
	const [pharmacy, setPharmacy] = useState(null);
	const [selectedPageType, setSelectedPageType] = useState(null);
	const [template, setTemplate] = useState('');
	const [setPharmacyLocations, setSelectedPharmacy, setPlatform, ecosystem, setEcosystem, locations, setLocations] = usePharmacyUserIconStore(
		(state) => [
			state.setPharmacyLocations,
			state.setSelectedPharmacy,
			state.setPlatform,
			state.ecosystem,
			state.setEcosystem,
			state.locations,
			state.setLocations,
		],
	);

	const user = JSON.parse(localStorage.getItem('userInfo'));

	useEffect(() => {
		if (user && user.pharmacy) {
			setSelectedPageType(user.pharmacy);
			setPharmacy(user.pharmacy);
			setEcosystem(Enviroment.___COUNTRY === 'MX' ? platformNames.mkt : platformNames.ecc);
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	console.log('seoecosystem', ecosystem);
	console.log('seopharmacy', pharmacy);
	console.log('seolocations', locations);

	useEffect(() => {
		if (pharmacy) {
			setLoading(true);
			setSelectedPharmacy(pharmacy);
			new Service()
				.getAllTemplates(ecosystem, pharmacy)
				.then((templatesResponse) => {
					const hasTemplates = templatesResponse.length > 0;
					const isValidEcosystem = ecosystem === platformNames.ecc || (ecosystem === platformNames.mkt && selectedPageType !== null);

					if (hasTemplates && isValidEcosystem) {
						setPharmacyLocations(templatesResponse);
						setPlatform(templatesResponse[0].platform);
						setLocations(templatesResponse[0].modules);
						setTemplate(templatesResponse[0].template);
					} else {
						setPharmacyLocations([]);
						setPlatform(null);
					}
					setLoading(false);
				})
				.catch((error) => {
					CustomNotification({ type: 'error', description: 'Ha ocurrido un error al obtener los recursos:', message: error });
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pharmacy, setPharmacyLocations, setSelectedPharmacy, setPlatform, ecosystem, setEcosystem, selectedPageType]);

	// useEffect(() => {
	// 	setPharmacyLocations([]);
	// 	setLocations([]);
	// }, [setPharmacyLocations, setLocations]);

	useEffect(() => {
		if (!pharmacy) return;
		setPharmacyLocations([]);
		setLocations([]);
	}, [pharmacy, ecosystem, setPharmacyLocations, setLocations]);


	return (
		<div className="admin-pharmacy-sliders-template">
			{loading ? (
				<Loading />
			) : locations?.length > 0 ? (
				<>
					<h2>Seleccionar logo a editar</h2>
					<Row gutter={[16, 16]}>
						{locations.map((card, key) => (
							<Fragment key={key}>
								<Col md={8} xs={24}>
									<CustomLink
										className="card-link"
										to={`/v2/pharmacy-icons/templates/${template}/locations/${card.location}/create`}
									>
										<CustomCard
											className="pharmacy-sliders-cards"
											title={
												<div className="card-header-container">
													<h3>{card.editable_name}</h3>
													<div className="inner-container">
														<p> {card?.image ? 'En uso' : 'Vacío'}</p>
													</div>
												</div>
											}
										>
											<CustomImage preview={false} src={card.img_cover} alt={card.editable_name} />
										</CustomCard>
									</CustomLink>
								</Col>
							</Fragment>
						))}
					</Row>
				</>
			) : (
				<></>
			)}
			<LoadingModal visible={openLoadingModal} />
		</div>
	);
}
